import {
  BusinessSchema,
  Business_InitialState,
  RadioSelect,
  RangeSlider,
  Select,
  TextArea,
  TextInput,
  useOptions
} from "@fla/components";
import BusinessIcon from "@fla/components/src/assets/svgs/business.svg";
import { yupResolver } from "@hookform/resolvers/yup";
import { selectConsentOrdersBase } from "pages/ConsentOrders";
import { FC } from "react";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";

interface IProps {
  formId: string;
  store: Business_InitialState;
  onSubmit: (values: Business_InitialState) => void;
}

const Details: FC<IProps> = ({ formId, store, onSubmit }) => {
  const { initialDetails } = useSelector(selectConsentOrdersBase);

  const { entityOptions, ownerV2Options, saleProceedsOptions, splitByOptions } = useOptions({ initialDetails });

  const { handleSubmit, control, watch, setValue } = useForm({
    mode: "all",
    defaultValues: store,
    resolver: yupResolver(BusinessSchema)
  });

  return (
    <form id={formId} onSubmit={handleSubmit(onSubmit)}>
      <div className="my-8 flex flex-col items-center justify-center">
        <img src={BusinessIcon} className="w-10 h-auto my-3" alt="bank" />
        <h3 className="font-bold">Business/Trust</h3>
      </div>
      <TextInput title="Name" control={control} name="name" id="name" placeholder="Eg Mustang Corp Pty Ltd" />

      <hr className="mt-7 mb-10 bg-gray-500 w-full" />

      <Select
        title="What type of entity is this"
        control={control}
        name="entity"
        id="entity"
        placeholder="Select"
        options={entityOptions}
      />

      <hr className="mt-7 mb-10 bg-gray-500 w-full" />

      <Select
        title={watch("entity") === "trust" ? "Who is the trustee" : "In whose name is this in?"}
        control={control}
        name="owner"
        id="owner"
        placeholder="Select"
        options={ownerV2Options}
      />

      <hr className="mt-7 mb-10 bg-gray-500 w-full" />

      <TextInput title="Approx Value" control={control} name="value" id="value" placeholder="" isAmount />

      <hr className="mt-7 mb-10 bg-gray-500 w-full" />
      <RadioSelect
        title="What happens to this"
        type="card-brief"
        id="split_by"
        name="split_by"
        control={control}
        options={splitByOptions as []}
        classes="my-8"
        onChange={v => {
          if (v === "percentage") {
            setValue("percentage", { user: "50", spouse: "50" });
          }
        }}
      />

      {watch("split_by") === "sell" ? (
        <RadioSelect
          title="How will the net sale proceeds be divided"
          type="card-brief"
          id="sale_proceeds"
          name="sale_proceeds"
          control={control}
          options={saleProceedsOptions as []}
          classes="my-8"
          onChange={v => {
            if (v === "percentage") {
              setValue("percentage", { user: "50", spouse: "50" });
            }
          }}
        />
      ) : null}

      {[watch("split_by"), watch("sale_proceeds")].includes("percentage") ? (
        <RangeSlider
          title="Split By A Percentage"
          control={control}
          id="percentage.user"
          name="percentage.user"
          exName={initialDetails?.spouse?.first_name || "N/A"}
          percentageOf={watch("value")}
          onChange={val => {
            setValue("percentage.spouse", `${100 - Number(val)}`);
          }}
        />
      ) : null}

      <TextArea
        title="Further comments you want us to know about this (optional)"
        control={control}
        name="comment"
        id="comment"
        placeholder="Description"
      />
    </form>
  );
};
export default Details;
